import React from 'react';
import { Link } from 'react-router-dom';

const CatalogueSidebarSubcategory = ({ catSlug, sub, isActive }) => {
  return (
    <Link
      to={`/catalogue/${catSlug}/${sub.slug}`}
      className={`block px-2 py-1.5 text-xs transition-colors rounded ${
        isActive
          ? 'bg-orange-50 text-orange-600 font-medium'
          : 'text-gray-600 hover:text-orange-600'
      }`}
      data-testid={`sidebar-sub-${sub.slug}`}
    >
      <span className="mr-1">{sub.emoji}</span>{sub.name}
    </Link>
  );
};

export default CatalogueSidebarSubcategory;
